import { Injectable } from '@angular/core';
import { ApiEnvironment } from '@lx/shared/types';
import { BaseConfigService } from './base-config.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigurationService extends BaseConfigService {
  protected fetchApiEnvironment(): ApiEnvironment {
    return {
      API_BASE_PATH: window['KLG_API_BASE_PATH'],
    };
  }
}
